import { render, staticRenderFns } from "./videoAndFileUpload.vue?vue&type=template&id=4ae88bd0&scoped=true"
import script from "./videoAndFileUpload.vue?vue&type=script&lang=js"
export * from "./videoAndFileUpload.vue?vue&type=script&lang=js"
import style0 from "./videoAndFileUpload.vue?vue&type=style&index=0&id=4ae88bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae88bd0",
  null
  
)

export default component.exports